import React from "react";

function Resume() {
  return (
    <section
      id="resume"
      className="py-20 bg-white px-6"
      data-aos="fade-up" // ✅ Section animation
    >
      <div
        className="max-w-3xl mx-auto text-center"
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        <h2 className="text-4xl font-bold text-blue-600 mb-4">My Resume</h2>
        <p className="text-gray-600 mb-6">
          Here’s my resume showcasing my skills, education, and projects. Feel free to download it.
        </p>

        <a
          href="/Karmadeep_Resume.pdf"
          download
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-blue-700 transition"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          📄 Download Resume
        </a>
      </div>
    </section>
  );
}

export default Resume;
